import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _Math$hypot from "@babel/runtime-corejs3/core-js-stable/math/hypot";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Children, cloneElement, useState, useEffect, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { usePopper } from 'react-popper';
import { useStyles, useToken, StyleSheet, text, margin, padding, border } from '@rexlabs/styling';
import { noop } from 'lodash';
var defaultArrowSize = 12;
var defaultStyles = StyleSheet({
  popout: {
    filter: function filter(_ref) {
      var token = _ref.token;
      return token('popout.filter', token('shadow.menuFilter'));
    },
    zIndex: function zIndex(_ref2) {
      var token = _ref2.token;
      return token('popout.zIndex', _parseInt(token('zIndex.base', 0)) + 1);
    }
  },
  arrow: {
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1,
      transform: 'rotate(45deg)',
      background: function background(_ref3) {
        var token = _ref3.token;
        return token('popout.background.color', token('color.container.static.default', 'white'));
      }
    }
  },
  arrowTop: {
    bottom: function bottom(_ref4) {
      var token = _ref4.token;
      return token('popout.arrow.size', _parseInt(token('arrow.size', defaultArrowSize)) / -2);
    }
  },
  arrowBottom: {
    top: function top(_ref5) {
      var token = _ref5.token;
      return token('popout.arrow.size', _parseInt(token('arrow.size', defaultArrowSize)) / -2);
    }
  },
  arrowLeft: {
    right: function right(_ref6) {
      var token = _ref6.token;
      return token('popout.arrow.size', _parseInt(token('arrow.size', defaultArrowSize)) / -2);
    }
  },
  arrowRight: {
    left: function left(_ref7) {
      var token = _ref7.token;
      return token('popout.arrow.size', _parseInt(token('arrow.size', defaultArrowSize)) / -2);
    }
  },
  wrapper: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    overflow: 'hidden'
  }, padding.styles({
    target: 'popout',
    all: 'm'
  })), margin.styles({
    target: 'popout',
    all: 'none'
  })), border.styles({
    target: 'popout',
    all: {
      radius: 'l'
    }
  })), {}, {
    minWidth: function minWidth(_ref8) {
      var token = _ref8.token;
      return token('popout.minWidth', 'auto');
    },
    maxWidth: function maxWidth(_ref9) {
      var token = _ref9.token;
      return token('popout.maxWidth', 'none');
    },
    backgroundColor: function backgroundColor(_ref10) {
      var token = _ref10.token;
      return token('popout.background.color', token('color.container.static.default', 'white'));
    },
    '&, & p': _objectSpread({}, text.styles({
      target: 'popout',
      fallback: 'normal.default',
      color: function color(_ref11) {
        var token = _ref11.token;
        return token('color.textStyle.body.default');
      }
    })),
    '& p': _objectSpread(_objectSpread({}, padding.styles({
      target: 'popout.paragraph',
      top: 'none',
      bottom: 'xs'
    })), {}, {
      '&:last-child': {
        paddingBottom: 0
      }
    })
  }),
  content: {
    position: 'relative',
    zIndex: 2,
    overflow: function overflow(_ref12) {
      var token = _ref12.token;
      return token('popout.content.overflow', 'auto');
    },
    maxHeight: function maxHeight(_ref13) {
      var token = _ref13.token;
      return token('popout.content.maxHeight', '90vh');
    },
    maxWidth: function maxWidth(_ref14) {
      var token = _ref14.token;
      return token('popout.content.maxHeight', '90vw');
    }
  }
});
var defaultArrowMargin = 4;
var displayName = 'Popout';

/**
 * The Popout is a component used to anchor an overlay to an element and insert arbitrary content defined by the user.
 */
export function Popout(_ref15) {
  var id = _ref15.id,
      children = _ref15.children,
      _ref15$placement = _ref15.placement,
      placement = _ref15$placement === void 0 ? 'bottom' : _ref15$placement,
      distanceProp = _ref15.distance,
      _ref15$onToggle = _ref15.onToggle,
      onToggle = _ref15$onToggle === void 0 ? noop : _ref15$onToggle,
      Content = _ref15.Content;
  var s = useStyles(defaultStyles, displayName);
  var token = useToken();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      referenceEl = _useState2[0],
      setReferenceEl = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      popperEl = _useState4[0],
      setPopperEl = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      arrowEl = _useState6[0],
      setArrowEl = _useState6[1];

  var arrowSize = token('popout.arrow.size', token('arrow.size', defaultArrowSize));

  var arrowHypot = _Math$hypot(arrowSize, arrowSize);

  var distance = token('popout.distance', distanceProp || Math.round(arrowHypot / 2) + defaultArrowMargin); // Ideally this is border radius + the arrow hypotenuse - arrow size
  // Border radius token is in `rem` and popperjs needs a number

  var arrowPadding = token('popout.arrowPadding', arrowHypot - arrowSize + 8);

  var _usePopper = usePopper(referenceEl, popperEl, {
    placement: placement,
    modifiers: [{
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, distance]
      }
    }, {
      name: 'preventOverflow',
      enabled: true,
      options: {
        padding: token('popper.overflowPadding', 12)
      }
    }, {
      name: 'arrow',
      enabled: true,
      options: {
        element: arrowEl,
        padding: arrowPadding
      }
    }, {
      name: 'flip',
      enabled: true
    }, {
      name: 'hide',
      enabled: true
    }]
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isOpen = _useState8[0],
      setOpen = _useState8[1];

  var toggle = useCallback(function () {
    setOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });
  }, []);
  var contentClicked = useRef(false);

  function handleContentClick() {
    contentClicked.current = true;
  }

  useEffect(function () {
    onToggle(isOpen);
  }, [isOpen, onToggle]);
  useEffect(function () {
    function handleOutsideClick() {
      if (!contentClicked.current) {
        setOpen(false);
      }

      contentClicked.current = false;
    }

    function handleKeyDown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        setOpen(false);
      }
    }

    if (isOpen) {
      window.document.addEventListener('click', handleOutsideClick);
      window.document.addEventListener('keydown', handleKeyDown);
      return function () {
        window.document.removeEventListener('click', handleOutsideClick);
        window.document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [id, children, isOpen]);
  var child = Children.only(children);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/cloneElement(child, {
    ref: setReferenceEl,
    onClick: toggle,
    tabIndex: 0
  }), isOpen && /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", _extends({}, s.with('popout')(styles === null || styles === void 0 ? void 0 : styles.popper), attributes === null || attributes === void 0 ? void 0 : attributes.popper, {
    ref: setPopperEl,
    onClick: handleContentClick
  }), /*#__PURE__*/React.createElement("div", _extends({}, s.with('arrow', {
    arrowTop: placement === null || placement === void 0 ? void 0 : _startsWithInstanceProperty(placement).call(placement, 'top'),
    arrowBottom: placement === null || placement === void 0 ? void 0 : _startsWithInstanceProperty(placement).call(placement, 'bottom'),
    arrowLeft: placement === null || placement === void 0 ? void 0 : _startsWithInstanceProperty(placement).call(placement, 'left'),
    arrowRight: placement === null || placement === void 0 ? void 0 : _startsWithInstanceProperty(placement).call(placement, 'right')
  })(_objectSpread(_objectSpread({}, styles.arrow), {}, {
    width: arrowSize,
    height: arrowSize
  })), attributes.arrow, {
    ref: setArrowEl
  })), /*#__PURE__*/React.createElement("div", s('wrapper'), /*#__PURE__*/React.createElement("div", s('content'), /*#__PURE__*/React.createElement(Content, {
    isOpen: isOpen,
    setOpen: setOpen,
    toggle: toggle
  })))), window.document.body));
}
Popout.displayName = displayName;
export default Popout;